import { Switch, Route } from "react-router-dom";
import React, { useEffect, createContext, useState } from "react";

import Checkout from "./components/Checkout";
import Hero from "./components/Hero";
import CheckoutSucceeded from "./components/CheckoutSucceeded";
import ProductsCatalog from "./components/ProductCatalog";
import Whoops404 from "./components/Whoops404";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Features from "./components/Features";
import CheckoutFailed from "./components/CheckoutFailed";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
const ShoppingCart = createContext();

const App = () => {
  const [cart, setCart] = useState([]);

  const physicalProducts = [
    {
      name: "Standard Size",
      image: "assets/time-2.jpg",
      desc: "Handcrafted on quality poster paper.",
      tags: ['11" wide', '8" long'],
      price: 20,
      priceID: "price_1Lz9AWJ8Rv6hixG5Smlppo9C",
      classNames: "lg:col-span-2",
      category: "physical",
    },
    {
      name: "Gift Size",
      image: "assets/sana.jpg",
      desc: 'Custom calligraphy drawn on 8" by 8" paper',
      tags: ['15" wide', '12" long'],
      price: 14,
      priceID: "price_1Lw9BhJ8Rv6hixG5ctbBX2nC",
      classNames: "lg:h-max lg:self-center",
      category: "physical",
    },
    {
      name: "Poster Size",
      image: "assets/ramadan-2.jpg",
      desc: "Custom calligraphy",
      tags: ['14" wide', '12" long'],
      price: 35,
      priceID: "price_1LzoT7J8Rv6hixG5gsFVcdkH",
      classNames: "lg:row-span-2",
      imageClassNames:
        "transform h-56 -rotate-45 scale-125 md:scale-[4] md:-rotate-[120deg] lg:transform-none lg:h-max",
      category: "physical",
    },
    {
      name: "Small Frame",
      image: "assets/lubna.jpg",
      desc: "Custom calligraphy",
      tags: ['14" wide', '12" long'],
      price: 19,
      priceID: "price_1LzoU8J8Rv6hixG5rIO6wiJ5",
      classNames: "lg:col-start-2 lg:col-span-2 lg:h-max",
      category: "physical",
    },
    {
      name: "Wall Frame Size",
      image: "assets/ramadan-kareem-wide.jpg",
      desc: "Custom calligraphy",
      tags: ['14" wide', '12" long'],
      price: 39,
      priceID: "price_1LzoQnJ8Rv6hixG5zWVIN9gv",
      classNames: "md:col-span-2 lg:col-start-2 lg:col-span-2 lg:h-max",
      category: "physical",
    },
  ];
  const digitalProducts = [
    {
      name: "Standard Size",
      image: "assets/time-2.jpg",
      desc: "Handcrafted on quality poster paper.",
      tags: ["12x8 Aspect Ratio"],
      price: 20,
      priceID: "price_1LzpufJ8Rv6hixG5D8Mb28Xy",
      classNames: "lg:col-span-2",
      category: "digital",
    },
    {
      name: "Poster Size",
      image: "assets/ramadan-2.jpg",
      desc: "Custom calligraphy",
      tags: ["16x8 Aspect Ratio"],
      price: 30,
      priceID: "price_1LzpvpJ8Rv6hixG5TeXVChaT",
      classNames: "lg:row-span-2",
      imageClassNames:
        "transform h-56 -rotate-45 scale-125 md:scale-[4] md:-rotate-[120deg] lg:transform-none lg:h-max",
      category: "digital",
    },
    {
      name: "Square Frame",
      image: "assets/lubna.jpg",
      desc: "Custom calligraphy",
      tags: ["1x1 aspect Ratio"],
      price: 19,
      priceID: "price_1LzpwwJ8Rv6hixG5R9vdtirs",
      classNames: "lg:col-span-2 lg:h-max",
      category: "digital",
    },
  ];

  // dev
  useEffect(() => console.log(cart), [cart]);

  return (
    <ShoppingCart.Provider value={{ cart, setCart }}>
      <div className="bg-base-100">
        <Switch>
          <Route exact path="/checkout">
            <Navbar />
            <Checkout />
          </Route>
          <Route path="/checkoutsuccess">
            <CheckoutSucceeded />
          </Route>
          <Route exact path="/checkoutfailure">
            <CheckoutFailed />
          </Route>
          <Route exact path="/products">
            <Navbar onHome={false} />
            <ProductsCatalog {...{ physicalProducts, digitalProducts }} />
          </Route>
          <Route exact path="/testemonials">
            <Navbar />
            <Hero />
            <Features />
            <About
              callback={() => {
                console.log("to reviews");

                gsap.to(window, {
                  duration: 1.2,
                  scrollTo: { y: "max", offsetY: -400 },
                });
              }}
            />
          </Route>
          <Route exact path="/about">
            <Navbar />
            <Hero
              callback={() => {
                console.log("to process");

                gsap.to(window, {
                  duration: 1.2,
                  scrollTo: { y: "#about" },
                });
              }}
            />
            <Features />

            <About />
          </Route>

          <Route path="/">
            <Navbar />
            <Hero />
            <Features />
            <About />
          </Route>
        </Switch>
      </div>
    </ShoppingCart.Provider>
  );
};
export { ShoppingCart };
export default App;
